import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useSelectFunctions = () => {
  //GetEmailConfig function
  const getEmailConfig = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        ApiCall.GET_EMAIL_CONFIG,
        {},
        LogonSessionID,
        SiteConfig.USER_ACCESS_SVC,
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response.EmailConfig;
  };

  //GetSystemPreferencesRacing function
  const getSystemPreferencesRacing = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        ApiCall.GET_SYSTEM_PREFERENCES_RACING,
        {},
        LogonSessionID,
        SiteConfig.RACING_MGMT_SVC,
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  return {
    getSystemPreferencesRacing,
    getEmailConfig,
  };
};
